import { TitleText } from 'text/part'
import { Article } from './types'

const UrlArticle: Article = {
  title: TitleText.url,
  headers: { jp: ['説明', 'URL'], en: ['Details', 'URL'] },
  rows: {
    jp: [
      ['神戸大学工学部', 'http://www.eng.kobe-u.ac.jp/'],
      ['神戸大学大学院システム情報学研究科', 'http://www.csi.kobe-u.ac.jp/'],
      [
        '計算科学専攻計算知能講座(中村グループ),CS24(旧CS27b)',
        'https://cs27.org/',
      ],
      [
        '背景画像オリジナル: "europia rainbow" by Robert Couse-Baker',
        'https://www.flickr.com/photos/29233640@N07/8535067907/in/photolist-e1dske-t1u24-XNouCs-UGhECP-MECwGp-paa8g-eEMAH-njr9yf-JmkCVu-Piyyg5-eEMzB-h5As5S-2H7W5-9UpeZY-z6BBvq-8FUQag-sGpBJB-4Y1pyu-dkJdKK-Qf7R53-dK8Qaz-52k7JK-a8cnrr-x5mqAU-8pwSXc-u3VK3-74CDyP-7VNzVZ-bY4kmy-uGm7w-7Gv7Yu-hnCh4S-6qDnzH-2Q2ELu-8jbnvq-5touGe-8jbnvY-8jbnuA-dgpTMy-2BtkE-kGTgU4-u3W3H-8QRsnL-dgpPLd-dq6jxh-dq69g8-dq65Ac-dq6eAZ-pB6hd-dq6678',
      ],
    ],
    en: [
      [
        'Faculty of Engineering, Kobe University',
        'http://www.eng.kobe-u.ac.jp/',
      ],
      [
        'Graduate School of System Informatics, Kobe University Graduate School',
        'http://www.csi.kobe-u.ac.jp/',
      ],
      ['Nakamura Laboratory CS24 (formerly CS27b)', 'https://cs27.org/'],
      [
        'Original Background Image: "europia rainbow" by Robert Couse-Baker',
        'https://www.flickr.com/photos/29233640@N07/8535067907/in/photolist-e1dske-t1u24-XNouCs-UGhECP-MECwGp-paa8g-eEMAH-njr9yf-JmkCVu-Piyyg5-eEMzB-h5As5S-2H7W5-9UpeZY-z6BBvq-8FUQag-sGpBJB-4Y1pyu-dkJdKK-Qf7R53-dK8Qaz-52k7JK-a8cnrr-x5mqAU-8pwSXc-u3VK3-74CDyP-7VNzVZ-bY4kmy-uGm7w-7Gv7Yu-hnCh4S-6qDnzH-2Q2ELu-8jbnvq-5touGe-8jbnvY-8jbnuA-dgpTMy-2BtkE-kGTgU4-u3W3H-8QRsnL-dgpPLd-dq6jxh-dq69g8-dq65Ac-dq6eAZ-pB6hd-dq6678',
      ],
    ],
  },
}

export default UrlArticle
